export const userflowSupportTriggerClass = 'help_icon';
